





















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { StatusCommande } from '@/enum/StatusCommande'
import  OrderList from '@/views/compte/OrderList.vue'
import { AlsCommande } from '@/models/als/AlsCommande'

@Component({
  name: 'OrderHistory',
  components:{OrderList} 
})
export default class OrderHistory extends Vue {
  private loading = false  
  time = new Date()
  commandeList = [] as Array<AloCommande>

  private get search(){
    return this.$store.myGetters.searchCommande
  }
   
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_COMMANDE(value)
  }

  private get commandePassedList() {
    return this.commandeList.filter(c=> this.time>new Date(c.panDatlivraison))
  }
  private get breakFastToComeList() {
    return this.commandeList.filter(c=> this.time<=new Date(c.panDatlivraison) && c.type == 'mdi-coffee')
  }
  private get lunchDinerToComeList() {
    return this.commandeList.filter(c=> this.time<=new Date(c.panDatlivraison) && c.type != 'mdi-coffee')
  } 


  updateTime() {
    this.time = new Date();
  } 
    
  created() {                

     const cmdFilter = {      
      histo:true,
      commit:false  
    } as AlsCommande

    this.loadCommandes(cmdFilter)             
  }


  loadCommandes(cmdFilter:AlsCommande){
    this.loading = true        
    this.$store.myActions.ADM_COMMANDE_REQUEST(cmdFilter).then((commandes) => {            
      this.commandeList = commandes
    }).finally(() => {      
      this.loading = false
    })   
  }
  
 
}
